export { isValidIBAN } from 'ibantools';

// Regex pour sécurité sociale
const ssRegex = new RegExp(
    '^' + // Début de chaîne
        '[12]' + // Sexe
        '[0-9]{2}' + // Année de naissance (aa)
        '(0[1-9]|1[0-2])' + // Mois de naissance (mm)
        '(2[AB]|[0-9]{2})[0-9]{3}' + // Lieu de naissance (numéro Insee : les 2 premiers chiffres = département puis les 3 suivants = code commune officiel)
        '[0-9]{3}' + // Numéro d'ordre permettant de distinguer les personnes nées au même lieu à la même période
        '([0-9]{2})' + // Numéro de contrôle (97 - (NIR mod 97))
        '$', // Fin de chaîne
);

/**
 * Fonction de vérification de sécurité sociale.
 */
export const isValidSecuritySocialNumber = (val) => {
    if (val == null || !val.match(ssRegex)) {
        return false;
    }

    const NIR = val.substring(0, 13);
    const key = val.substring(13);

    if (+key !== 97 - (NIR % 97)) {
        return false;
    }

    return true;
};

const siretRegex = /^\d{14}$/;

/**
 * Vérifie la conformité d'un SIRET. Tiré de https://github.com/jbdemonte/vat-siren-siret/ mais
 * copié ici étant donné qu'elle ne risque pas de changer et qu'elle est extrémement courte.
 */
export const isValidSIRET = (val: string) => {
    return siretRegex.test(val) && checkLuhn(val);
};

/**
 * Return TRUE if the string evaluation on the Luhn algorithm succeeds
 */
function checkLuhn(value: string): boolean {
    let digit: number;
    let sum = 0;
    let even = false;
    for (let i = value.length - 1; i >= 0; i -= 1) {
        digit = parseInt(value[i], 10);
        if (even) {
            digit += digit;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
        even = !even;
    }
    return sum % 10 === 0;
}
